//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'RequestDescriptionField',
  components: {
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    propertyKey: {
      type: String, // applicantDescription, description
      required: true
    },
    label: {
      type: String,
      default: 'Описание'
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    icon: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      descriptionOptions: null,
      descriptionOptionSelected: null
    }
  },
  computed: {
    descriptionValue: {
      get: function () {
        return this.request[this.propertyKey]
      },
      set: function (value) {
        this.request[this.propertyKey] = value
      }
    },
    descriptionReadonly: function () {
      return this.readonly ||
        this.request._configuration.isFieldReadonly('applicantDescription') // propertyKey ?
    },
    inputBlockedByOption: function () {
      return !!this.descriptionOptionSelected && !this.descriptionOptionSelected.descriptionEditable
    },
    inputReadonly: function () {
      return this.inputBlockedByOption || this.descriptionReadonly
    },
    descriptionRequired: function () {
      return this.request._configuration.isFieldRequired('applicantDescription') && !this.descriptionReadonly
    },
    descriptionRules: function () {
      if (this.descriptionRequired) {
        return [val => (!val || !val.trim()) && 'Обязательное поле' || null]
      }
      return null
    }
  },
  watch: {
    'request._configuration.breakageTypes': function () {
      // const requestType = this.request.requestType
      const descriptionOptions = this.request._configuration.breakageTypes || null
      this.setDescriptionOptions(descriptionOptions)
    }
  },
  methods: {
    prepareDescription: function () {
      this.descriptionOptionSelected = null
    },
    setDescriptionOptions: function (descriptionOptions) {
      this.descriptionOptions = descriptionOptions

      let selectedOption = null
      if (descriptionOptions && descriptionOptions.length) {
        if (this.request.isCreationState || !this.descriptionValue) {
          selectedOption = descriptionOptions.find(opt => opt.default)
        } else {
          const breakageTypeKey = this.request.breakageTypeKey
          if (breakageTypeKey) {
            selectedOption = descriptionOptions.find(opt => opt.key === breakageTypeKey)
          } else { // для обратной совместимости
            selectedOption = descriptionOptions.find(opt => opt.name === this.descriptionValue)
          }
          if (!selectedOption) {
            selectedOption = descriptionOptions.find(opt => opt.default && opt.descriptionEditable)
          }
        }
      }
      this.descriptionOptionSelected = selectedOption || null
      if (selectedOption) {
        this.request.breakageTypeKey = selectedOption.key
      }
    },
    onSelectDescriptionOption: function (option) {
      this.descriptionOptionSelected = option
      if (!option.descriptionEditable) {
        this.descriptionValue = option.name
        this.request.breakageTypeKey = option.key
      }
    }
  }
}
